import { apiClient } from '@/lib/api/client';
import {
  LoginResponse,
  RegisterData,
  RegisterResponse,
  RefreshTokenResponse,
  ResetPasswordData,
  ChangePasswordData,
} from '../types/auth.types';

export const authService = {
  /**
   * Login with OAuth2 form data
   * POST /auth/login
   */
  login: async (credentials: { email: string; password: string }): Promise<LoginResponse> => {
    // Convert to form data for OAuth2 flow
    const formData = new URLSearchParams();
    formData.append('username', credentials.email); // email is sent as username
    formData.append('password', credentials.password);
    formData.append('grant_type', 'password');

    const { data } = await apiClient.post<LoginResponse>('/auth/login', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return data;
  },

  /**
   * Register new user
   * POST /auth/register
   */
  register: async (userData: RegisterData): Promise<RegisterResponse> => {
    const { data } = await apiClient.post<RegisterResponse>('/auth/register', userData);
    return data;
  },

  /**
   * Refresh access token
   * POST /auth/refresh
   */
  refreshToken: async (refreshToken: string): Promise<RefreshTokenResponse> => {
    const { data } = await apiClient.post<RefreshTokenResponse>('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return data;
  },

  /**
   * Request password reset email
   * POST /auth/reset-password-request
   */
  requestPasswordReset: async (email: string): Promise<string> => {
    const { data } = await apiClient.post<string>('/auth/reset-password-request', { email });
    return data;
  },

  /**
   * Reset password with token
   * POST /auth/reset-password
   */
  resetPassword: async (resetData: ResetPasswordData): Promise<string> => {
    const { data } = await apiClient.post<string>('/auth/reset-password', resetData);
    return data;
  },

  /**
   * Change password for authenticated user
   * POST /auth/change-password
   */
  changePassword: async (passwordData: ChangePasswordData): Promise<string> => {
    const { data } = await apiClient.post<string>('/auth/change-password', passwordData);
    return data;
  },
};
